<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <div class="relative flex items-center">
        <button
            class="absolute z-50 flex items-center justify-center w-4 h-4 border rounded-full md:w-6 md:h-6 border-primary -left-5 md:-left-8"
            (click)="goback()">
            <mat-icon
                class="w-[5px] mr-[1px] h-[3px] min-w-[5px] min-h-[3px] md:w-[7.5px] md:h-[4.5px] md:min-w-[7.5px] md:min-h-[4.5px] text-primary rotate-90"
                svgIcon="icons:arrow-icon">
            </mat-icon>
        </button>
        <h1 class=" text-primary-black-01 title-6 md:title-3">Formulario 24</h1>
    </div>

    <div
        class="grid w-full grid-cols-1 p-3 mt-3 rounded-lg sm:grid-cols-2 md:grid-cols-3 sm:gap-y-3.5 text-primary-black-01 bg-primary-gray-03 bg-opacity-20">
        <ng-container *ngFor="let item of datasourceForm24.plantillas_pagare_formulario">
            <ng-container [ngSwitch]="item.NOMBRE_RECURSO">
                <ng-container *ngSwitchCase="'RUT'">
                    <div>
                        <p class="inline-block sm:block title-9">
                            RUT
                        </p>
                        <p class="inline-block sm:hidden">:&nbsp;</p>
                        <p class="inline-block sm:block paragraph-2">{{item.VALOR_RECURSO}}</p>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'RAZON_SOCIAL'">
                    <div>
                        <p class="inline-block sm:block title-9">
                            Razón Social
                        </p>
                        <p class="inline-block sm:hidden">:&nbsp;</p>
                        <p class="inline-block sm:block paragraph-2">{{item.VALOR_RECURSO}}</p>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'REPRESENTANTE_LEGAL'">
                    <div>
                        <p class="inline-block sm:block title-9">
                            Representante Legal
                        </p>
                        <p class="inline-block sm:hidden">:&nbsp;</p>
                        <p class="inline-block sm:block paragraph-2">{{item.VALOR_RECURSO}}</p>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'FONO'">
                    <div>
                        <p class="inline-block sm:block title-9">
                            Fono
                        </p>
                        <p class="inline-block sm:hidden">:&nbsp;</p>
                        <p class="inline-block sm:block paragraph-2">{{item.VALOR_RECURSO}}</p>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'DIRECCION'">
                    <div>
                        <p class="inline-block sm:block title-9">
                            Dirección
                        </p>
                        <p class="inline-block sm:hidden">:&nbsp;</p>
                        <p class="inline-block sm:block paragraph-2">{{item.VALOR_RECURSO}}</p>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'COMUNA'">
                    <div>
                        <p class="inline-block sm:block title-9">
                            Comuna
                        </p>
                        <p class="inline-block sm:hidden">:&nbsp;</p>
                        <p class="inline-block sm:block paragraph-2">{{item.VALOR_RECURSO}}</p>
                    </div>
                </ng-container>

            </ng-container>

        </ng-container>
    </div>



    <mat-form-field appearance="fill" class="w-full mt-5 md:mt-10 md:w-72">
        <mat-label>Periodo </mat-label>
        <mat-select class="h-[54px]" [(value)]="selectPeriod" (selectionChange)="changePeriod()">
            <mat-option *ngFor="let period of periods" [value]="period.value">
                {{ period.viewValue }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <h2 class="text-primary-black-01 title-8">Resumen</h2>

    <!-- TABLE DESKTOP -->
    <app-mat-custom-table  (action)="onTableAction($event)" [use_selection]="false"
        [use_detail]="false" [dataset]="pagareResumenDataSource" [columns]="columnsResumen" [showPaginator]="false">
    </app-mat-custom-table>

    <p class="mt-3 text-primary-black-01 paragraph-5">Descripción (Folios)</p>

    <div class="border w-full md:w-[619px] h-[75px] border-primary-gray-01 rounded flex items-center px-5 my-3">
        <p class="text-primary-black-01 paragraph-5">Folios: {{foliosValidos}}</p>
    </div>

    <!-- TABLE DESKTOP -->
    <app-mat-custom-table (action)="onTableAction($event)" [use_selection]="false"
        [use_detail]="false" [selection]="selection" [dataset]="resumenImpuestoDataSource" [columns]="columns" [showPaginator]="false">
    </app-mat-custom-table>

    <div class="flex mt-5 md:justify-end md:mt-0">
        <a mat-button href="https://www4.sii.cl/sifmformulario24ui/index.html#!/formulario24" target="_blank" mat-flat-button color="primary" class="w-full md:w-auto">Ir a descargar formulario </a>
    </div>
</main>